import { computed } from "vue";
import { useStore } from "vuex";
import { createGlobalState } from "@vueuse/core";

import { LicenceWithSeats } from "@/types/licenceSolutions.ts";

export const useEnabledSolutions = createGlobalState(() => {
  const store = useStore();

  const enabledSolutions = computed(() =>
    store.state.solutions.solutions.map((solution: LicenceWithSeats) => {
      return {
        ...solution,
        service: {
          name: solution.solution_name,
          uuid: solution.solution_uuid,
        },
      };
    }),
  );
  return { enabledSolutions };
});

export default {};
